// extracted by mini-css-extract-plugin
export default {"root":"ToggleSwitch_root__G8uod","track":"ToggleSwitch_track__fnzNR","checked":"ToggleSwitch_checked__sbMpF","thumb":"ToggleSwitch_thumb__wRhEe","icon":"ToggleSwitch_icon__u-yim"};